import { render, staticRenderFns } from "./home-recent-projects.component.vue?vue&type=template&id=f1152bee&scoped=true&"
import script from "./home-recent-projects.component.vue?vue&type=script&lang=ts&"
export * from "./home-recent-projects.component.vue?vue&type=script&lang=ts&"
import style0 from "./home-recent-projects.component.vue?vue&type=style&index=0&id=f1152bee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1152bee",
  null
  
)

export default component.exports